import { useState, useEffect } from 'react'
import Debounce from '../Textboxs/Debounce'

const Select = ({
  className,
  id,
  children,
  isRequired,
  msgValidate,
  name,
  value,
  onChange,
  debounceTime,
}: SelectInterface) => {
  const [validate, setValidate] = useState<boolean>(isRequired !== true)
  useEffect(() => {
    if (value !== undefined && value !== '' && value !== null) setValidate(true)
    else setValidate(false)
  }, [value])
  const change = (e) => {
    if (isRequired === false) {
      onChange?.(e)
      return
    }
    if (!e.currentTarget.value || e.currentTarget.value === '')
      setValidate(false)
    else setValidate(true)

    onChange &&
      Debounce({
        func: () => onChange(e),
        timeout:
          debounceTime != undefined || debounceTime != null
            ? debounceTime
            : 600,
      })
  }
  return (
    <>
      <select
        defaultValue={value}
        id={id}
        onChange={(e) => {
          change(e)
        }}
        name={name}
        rayteb-reqvalid={`${isRequired && validate === false}`}
        rayteb-reqmessage={
          validate === false
            ? msgValidate
              ? msgValidate
              : 'نمیتواند خالی باشد'
            : ''
        }
        className={`${className} bg-gray-50 outline-0 text-primary xs:text-xs  sm:text-sm rounded-lg
         border border-disable
          p-1 dark:bg-gray-700 dark:border-gray-600  bg-white ${
            isRequired
              ? validate === false
                ? '!border-[#dc3545] !border-2'
                : '!border-2 !border-[#28a745]'
              : ''
          }`}
      >
        {children}
      </select>
    </>
  )
}

export default Select
